module.exports = "images/LOADER_logo.396ebf70.gif";